<template>
  <main>
    <cModal @reload-event="reset" />
    <uModal @reload-event="reset" />
    <h2 class="ttl"><img src="/img/ico_community.png" alt="コミュニティ" width="40" class="mb30"><br>{{$t('community')}}</h2>
    <p class="btn-room">
      <router-link to="" @click.native="createRoom()">{{$t('addRoom')}}</router-link>
    </p>
    <div class="account-box mb30">
      <p class="txt-mini center">{{$t('sortOrder')}}</p>
      <p class="txt-selectbox">
        <select v-model="sortId" @change="sort">
          <option v-for="roomSort in this.roomSorts" :key="roomSort.id" :value="roomSort.id">
            {{$t(roomSort.label)}}
          </option> 
        </select>
      </p>
    </div>
    <div id="com-area">
      <div v-for="(room , index) in rooms" :key="index">
        <h3 class="break-word"><router-link :to="{ name: 'Room' , params: { id: room.id } }">{{ room.name }}</router-link></h3>
        <p>{{ room.nickname }}</p>
        <p v-if="eq(room.userId, uid)" class="btn-room2">
          <router-link to="" @click.native="editRoom(room.id, room.name)">{{$t('editRoom')}}</router-link>
        </p>
      </div>
      <span class="morelink link1" @click="load" :hidden="hideMore">{{$t('moreRoom')}}</span>
   </div>
  </main >
</template>

<script>
import firebase from 'firebase'
import roomSorts from '@/constants/SortValuesEnum'
import cModal from '@/modal/CreateRoomModal'
import uModal from '@/modal/UpdateRoomModal'
import utils from '@/utils/Utils'

export default {
  name: 'Rooms',
  mixins: [utils , roomSorts],
  data () {
    return {
      db: firebase.firestore(),
      uid: firebase.auth().currentUser.uid,
      rooms: [],
      sortId: 1,
      page: {
        current: null,
        limit: 10,
      },
      hideMore: true
    }
  },
  components: {
   cModal,
   uModal,
  },
  created () {
    this.load()
  },
  methods: {
    async load () {
      const roomSort = this.roomSorts.find(e => e.id == this.sortId)
      let ref = this.db.collection("rooms").where("display_status", "==", 1)
      ref = ref.orderBy(roomSort.value, roomSort.orderBy)
      if (this.page.current) {
        ref = ref.startAfter(this.page.current)
      }
      try {
        const snapshot = await ref.limit(this.page.limit).get()
        this.page.current = snapshot.docs[snapshot.size - 1]
        this.hideMore = !this.page.current || snapshot.size < this.page.limit
        snapshot.forEach((doc) => {
          let data = doc.data()
          this.rooms.push({
            id: doc.id,
            name: data.name,
            nickname: data.nickname,
            userId: data.user_id,
            commentedAt: data.commented_at,
            createdAt: data.created_at,
            updatedAt: data.updated_at,
          })
        })
      } catch (error) {
        this.$toasted.error(this.$t('failData'))
      }
    },
    sort () {
      this.rooms = []
      this.page.current = null
      this.load()
    },
    reset () {
      this.sortId = 1
      this.sort()
    },
    createRoom () {
      this.$modal.show("create")
    },
    editRoom (id, name) {
      this.$modal.show("edit", { id: id, name: name })
    },
  },
}
</script>
